<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />

      <div class="d-flex justify-content-between">
        <h3>
          <feather-icon class="ml-50" icon="PackageIcon" size="20" />
          إدارة واجهات تشبيك
        </h3>
      </div>
      <hr />

      <div class="mt-1">
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="text-secondary pl-1">امنح</h4>
          <b-button
            v-can="{ slug: $route.meta.slug, action: 'C' }"
            variant="success"
            @click="
              isSupportObjectModalVisible = true;
              isRequest = false;
            "
          >
            <feather-icon icon="PlusIcon" /> إضافة</b-button
          >
        </div>

        <hr />

        <data-table
          v-can="{ slug: $route.meta.slug, action: 'S' }"
          :fields="tableFields"
          :items="supportPagesContent.assistObjects"
          ref="objectsTable"
          ep="v2/assist-objects"
        >
          <template #cell(assistCategory)="{ value }">
            {{ value.name }}
          </template>
          <template #cell(actions)="{ item }">
            <div class="d-flex justify-content-end">
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                size="sm"
                @click="onDeleteClicked(item.id)"
                variant="flat-danger"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                size="sm"
                @click="onEditObjectClicked(item)"
                variant="flat-info"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </div>
          </template>
        </data-table>
      </div>
      <hr />
      <div class="mt-4">
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="text-secondary pl-1">استفد</h4>
          <b-button
            v-can="{ slug: $route.meta.slug, action: 'C' }"
            variant="success"
            @click="
              isSupportRequestModalVisible = true;
              isRequest = true;
            "
          >
            <feather-icon icon="PlusIcon" /> إضافة</b-button
          >
        </div>

        <hr />

        <data-table
          v-can="{ slug: $route.meta.slug, action: 'S' }"
          :fields="tableFields"
          :items="supportPagesContent.assistObjects"
          ref="requestsTable"
          ep="v2/assist-objects?demanded=true"
        >
          <template #cell(assistCategory)="{ value }">
            {{ value.name }}
          </template>
          <template #cell(actions)="{ item }">
            <div class="d-flex justify-content-end">
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                size="sm"
                @click="onDeleteClicked(item.id, true)"
                variant="flat-danger"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <b-button
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                size="sm"
                @click="onEditRequestClicked(item)"
                variant="flat-info"
                class="btn-icon rounded-circle"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </div>
          </template>
        </data-table>
      </div>
      <form-modal
        static
        title="امنح"
        ref="supportObjectForm"
        v-model="isSupportObjectModalVisible"
        :formSchema="supportObjectFormSchema"
        @confirm="onSupportModalConfirmed"
        :loading="working"
      />
      <form-modal
        static
        title="استفد"
        ref="supportRequestForm"
        v-model="isSupportRequestModalVisible"
        :formSchema="supportObjectFormSchema"
        @confirm="onSupportModalConfirmed"
        :loading="working"
      />
    </div>
  </b-card>
</template>
<script>
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import DataTable from "@/components/data-table";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import {
  BCard,
  BTableLite,
  BButton,
  BFormGroup,
  BRow,
  BCol,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormModal from "@/components/FormModal.vue";
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    BCard,
    BTableLite,
    BButton,
    BFormGroup,
    BRow,
    BCol,
    LoadingOverlay,
    DataTable,
    FormModal,
    ValidationProvider,
    quillEditor,
  },
  data: () => {
    return {
      supportModal: false,
      info: {},
      isSupportObjectModalVisible: false,
      isSupportRequestModalVisible: false,
      isRequest: false,
      supportMeModal: false,
      giveSupportModal: false,
      tableFields: [
        { key: "assistCategory", label: "التصنيف" },
        { key: "title", label: "الاسم" },
        { key: "governorate.name_ar", label: "المحافظة" },
        { key: "description", label: "الوصف" },
        { key: "count", label: "العدد" },
        { key: "actions", label: " " },
      ],
      supportMeSchema: {
        title: {
          key: "title",
        },
      },
      giveSupportSchema: {
        title: {
          key: "title",
        },
      },
      supportObjectFormSchema: {
        title: {
          component: "FormInput",
          key: "title",
          attrs: {
            label: "الاسم",
            rules: "required",
          },
        },
        description: {
          component: "FormTextarea",
          key: "description",
          attrs: {
            label: "الوصف",
            rules: "required",
          },
        },
        count: {
          component: "FormCleave",
          key: "count",
          attrs: {
            label: "العدد",
            rules: "required|min:1",
            isNumber: true,
            charsCount: 10,
          },
        },
        assist_category_id: {
          component: "FormSelect",
          key: "assist_category_id",
          attrs: {
            label: "التصنيف",
            rules: "required",
            id: "SupportCategories",
            ep: "v2/selects/assist-categories",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name,
          },
        },
        governorate_id: {
          component: "FormSelect",
          key: "governorate_id",
          attrs: {
            label: "المحافظة",
            rules: "required",
            id: "SupportGovernoarate",
            ep: "v2/selects/governorates",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters("Tashbeek/TashbeekManagement", [
      "supportPagesContent",
      "loading",
      "working",
    ]),
  },
  methods: {
    ...mapActions("Tashbeek/TashbeekManagement", [
      "getSupportPagesContent",
      "updateSupportPagesObject",
      "createSupportPagesObject",
      "deleteSupportPagesObject",
      "updateSupportPagesContent",
    ]),
    onDeleteClicked(id, isRequest) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الخدمة ؟", {
          title: "تأكيد حذف الخدمة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteSupportPagesObject(id).then(() => {
              if (isRequest) this.$refs.requestsTable.refreshTable();
              else this.$refs.objectsTable.refreshTable();
            });
          }
        });
    },
    onEditObjectClicked(form) {
      this.$refs.supportObjectForm.init({
        id: form.id,
        title: form.title,
        description: form.description,
        count: form.count,
        assist_category_id: form.assistCategory.id,
        governorate_id: form.governorate ? form.governorate.id : null,
      });
      this.isRequest = false;
      this.isSupportObjectModalVisible = true;
    },
    onEditRequestClicked(form) {
      this.$refs.supportRequestForm.init({
        id: form.id,
        title: form.title,
        description: form.description,
        count: form.count,
        assist_category_id: form.assistCategory.id,
        governorate_id: form.governorate ? form.governorate.id : null,
        demanded: true,
      });
      this.isRequest = true;
      this.isSupportRequestModalVisible = true;
    },
    async onSupportModalConfirmed(form) {
      if (form.id) {
        if (this.isRequest)
          await this.updateSupportPagesObject({ ...form, demanded: true });
        else await this.updateSupportPagesObject({ ...form, demanded: false });
      } else {
        if (this.isRequest)
          await this.createSupportPagesObject({ ...form, demanded: true });
        else await this.createSupportPagesObject({ ...form, demanded: false });
      }

      if (this.isRequest) this.$refs.requestsTable.refreshTable();
      else this.$refs.objectsTable.refreshTable();

      this.isSupportObjectModalVisible = false;
      this.isSupportRequestModalVisible = false;
      this.isRequest = false;
    },

    onSupportMeEdit() {
      this.$refs.supportMeForm.init({
        get_supported_description:
          this.supportPagesContent.get_supported_description,
      });
      this.supportMeModal = true;
    },
    onGiveSupportEdit() {
      this.$refs.giveSupportForm.init({
        supporting_description: this.supportPagesContent.supporting_description,
      });
      this.giveSupportModal = true;
    },
    async updateContent(form) {
      await this.updateSupportPagesContent({
        form,
        id: this.supportPagesContent.id,
      });
      this.supportMeModal = false;
      this.giveSupportModal = false;
      this.getSupportPagesContent();
    },
  },
  created() {
    this.getSupportPagesContent();
  },
};
</script>
